<template>
  <transition>
    <div class="age-verification">
      <div class="loading" v-if="loading">LOADING <img src="@/assets/icons/loading.svg" /></div>
      <div class="age-verification__inner">
        <img src="@/assets/icons/verification-logo.svg" />
        <div class="title">QUIZ</div>
        <form @submit.prevent="validate">
        <div class="bottom-row" :class="{hidden: loading}">
          <div class="subtitle">Παρακαλούμε συμπληρώστε τα παρακάτω στοιχεία  για να μπείτε στην εφαρμογή.</div>
<!--          <div class="field">
            <div class="field_title">ΟΝΟΜΑΤΕΠΩΝΥΜΟ</div>
            <input placeholder="ΟΝΟΜΑ" v-model="firstname" required/> <input placeholder="ΕΠΩΝΥΜΟ" v-model="lastname" required/>
          </div>
          <div class="field">
            <div class="field_title">E-MAIL & ΤΗΛΕΦΩΝΟ</div>
            <input placeholder="E-MAIL" type="email" v-model="email" required/> <input placeholder="ΤΗΛΕΦΩΝΟ" v-model="phone" required/>
          </div>-->
          <div class="field">
<!--            <div class="field_title">ΜΗΝΑΣ & ΕΤΟΣ ΓΕΝΝΗΣΗΣ</div>-->
            <v-select :options="months" :clearable="false" :searchable="false" placeholder="ΜΗΝΑΣ" v-model="month"></v-select>
            <v-select :options="years" :clearable="false" :searchable="false" placeholder="ΕΤΟΣ" v-model="year"></v-select>
          </div>
<!--          <div class="checkbox">
            <label for="terms">
            <input type="checkbox" id="terms" required/>
              <div>Με την παρούσα υποβολή αποδέχομαι τους <a @click="terms=true">όρους χρήσης</a> και παραχωρώ δικαιωμα στην Παπαστράτος Α.Ε. να διαχεριστεί τα προσωπικά μου δεδομένα</div>
            </label>
          </div>-->
        </div>
        <Button class="validate">ΥΠΟΒΟΛΗ</Button>
        </form>
      </div>
      <transition>
        <div class="modal" v-if="error">
          <div class="modal-inner">
            <div class="title">Λυπούμαστε!</div>
            <div class="text">Αυτός ο ιστότοπος προορίζεται αποκλειστικά για χρήστες προϊόντων νικοτίνης ή καπνού άνω των 18 ετών. Δεν μπορείς να προχωρήσεις στο επόμενο βήμα.</div>
          </div>
        </div>
      </transition>
      <transition>
        <div class="modal terms" v-if="terms">
          <div class="modal-inner">
            <div class="top-row">
              <img src="@/assets/icons/info.svg" />
              <img class="close" src="@/assets/icons/modal-close.svg" @click="terms=false"/>
            </div>
            <div class="title">Όροι Χρήσης</div>
            <div class="text">
                <h3 id="pmi-pn">ΔΗΛΩΣΗ ΠΡΟΣΤΑΣΙΑΣ ΑΠΟΡΡΗΤΟΥ ΚΑΤΑΝΑΛΩΤΩΝ ΤΗΣ PMI</h3>
                <p>
                  Η προστασία των προσωπικών δεδομένων είναι σοβαρή υπόθεση για εμάς. Η παρούσα δήλωση σας ενημερώνει για το ποιοι είμαστε, ποιες πληροφορίες σχετικά με εσάς συλλέγουμε και τι κάνουμε με αυτές. Κάντε κλικ στο «Μάθετε περισσότερα» που υπάρχει σε κάθε ενότητα για περισσότερες πληροφορίες.</p><p>Παρακαλούμε, διαβάστε επίσης τους όρους χρήσης που αφορούν την υπηρεσία που σας ενδιαφέρει. Εκεί θα βρείτε περισσότερες πληροφορίες σχετικά με τον τρόπο με τον οποίο δραστηριοποιούμαστε και τυχόν περιορισμούς επιλεξιμότητας που ενδέχεται να ισχύουν.
              </p>
                <h4>
                  <a id="a__Ποιοι_είμαστε_"></a>Ποιοι είμαστε;
                </h4>
                <p>Είμαστε μέλος της Philip Morris International. Τα στοιχεία μας (επωνυμία, διεύθυνση κ.λπ.) θα σας παρασχεθούν μεμονωμένα κατά τη στιγμή (ή για επιβεβαίωση) της συλλογής πληροφοριών σχετικά με εσάς, για παράδειγμα, σε δήλωση σε μία εφαρμογή ή ιστότοπο, ή σε ένα e-mail που θα περιέχει έναν σύνδεσμο προς την παρούσα δήλωση.</p>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <ul>
                  <li>
                    PMI: Philip Morris International, κορυφαίος διεθνής όμιλος προϊόντων καπνού. Αποτελείται από διάφορες εταιρείες αποκαλούμενες και  «συνδεδεμένες εταιρείες».
                  </li>
                  <li>
                    Συνδεδεμένες εταιρείες PMI: Κάθε μέλος του ομίλου εταιρειών Philip Morris International αποτελεί «συνδεδεμένη εταιρεία της PMI». Οι λέξεις «εμείς» (ή «εμάς» ή «μας») αναφέρονται στη συνδεδεμένη εταιρεία PMI που συλλέγει αρχικά πληροφορίες σχετικά με εσάς.
                  </li>
                  <li>
                    Προϊόν PMI: ένα δικό μας <a href="https://www.pmi.com/investor-relations/overview/building-leading-brands">προϊόν</a> ή ένα προϊόν άλλης συνδεδεμένης εταιρείας της PMI.
                  </li>
                </ul>
                <h4><a id="a__Πώς_συλλέγουμε_πληροφορίες_σχετικά_με_εσάς_"></a>Πώς συλλέγουμε πληροφορίες σχετικά με εσάς;</h4>
                <p>Μπορούμε να συλλέξουμε πληροφορίες για εσάς με διάφορους τρόπους.</p>
                <ul>
                  <li>
                    Μπορείτε να μας δώσετε απευθείας εσείς τις πληροφορίες (π.χ. συμπληρώνοντας μια φόρμα ή τηλεφωνικώς).
                  </li>
                  <li>
                    Μπορούμε να συλλέξουμε πληροφορίες αυτόματα (π.χ. όταν χρησιμοποιείτε μια εφαρμογή ή έναν ιστότοπο της PMI).
                  </li>
                  <li>
                    Μπορούμε να αποκτήσουμε πληροφορίες από τρίτους (π.χ. πληροφορίες που είναι δημόσια διαθέσιμες σε πλατφόρμες μέσων κοινωνικής δικτύωσης, όπως Facebook και Twitter).
                  </li>
                </ul>
                <p>Στην παρούσα δήλωση αναφέρουμε όλες τις μεθόδους με τις οποίες μπορείτε να έρθετε σε επαφή μαζί μας ως «σημεία επαφής της PMI». Τα σημεία επαφής της PMI είναι τόσο φυσικά (π.χ. καταστήματα λιανικής πώλησης και εκδηλώσεις) όσο και ψηφιακά (π.χ. εφαρμογές και ιστότοποι).</p>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Μπορούμε να συλλέξουμε πληροφορίες απευθείας από εσάς. Συνήθως αυτό θα συμβεί όταν:</p>
                <ul>
                  <li>
                    εγγράφεστε ως μέλος στις βάσεις δεδομένων μας (για παράδειγμα, αυτοπροσώπως, μέσω εφαρμογής ή διαδικτυακά),
                  </li>
                  <li>
                    αγοράζετε προϊόντα ή υπηρεσίες της PMI σε ένα κατάστημα λιανικής πώλησης,
                  </li>
                  <li>
                    κάνετε λήψη ή χρήση ενός ψηφιακού σημείου επαφής (π.χ. μιας εφαρμογής ή ενός ιστότοπου),
                  </li>
                  <li>
                    επικοινωνείτε μαζί μας μέσω ενός σημείου επαφής ή μέσω ηλεκτρονικού ταχυδρομείου, μέσων κοινωνικής δικτύωσης ή τηλεφωνικώς,
                  </li>
                  <li>
                    καταχωρίζετε μια συσκευή σε εμάς,
                  </li>
                  <li>εγγράφεστε σε μια πύλη της PMI,</li>
                  <li>
                    εγγράφεστε για να λαμβάνετε δελτία τύπου της PMI, ειδοποιήσεις μέσω e-mail ή εμπορικές επικοινωνίες
                  </li>
                  <li>
                    συμμετέχετε σε έρευνες της PMI ή σε διαγωνισμούς ή προωθητικές ενέργειες PMI (όπου επιτρέπεται από τον νόμο) ή
                  </li>
                  <li>
                    συμμετέχετε σε εκδήλωση που έχει οργανώσει μια συνδεδεμένη εταιρεία της PMI.
                  </li>
                </ul>
                <p>Μπορούμε να συλλέξουμε πληροφορίες για εσάς αυτόματα. Συνήθως αυτό θα συμβεί όταν:</p>
                <ul>
                  <li>
                    επισκέπτεστε ένα κατάστημα που πωλεί προϊόντα PMI (π.χ. με τη συλλογή των δεδομένων σας κατά την ολοκλήρωση της αγοράς ή μέσω αισθητήρων που βρίσκονται στο κατάστημα που συνδέονται με τεχνολογία κινητών συσκευών),
                  </li>
                  <li>
                    συμμετέχετε σε μια εκδήλωση που έχει οργανώσει μια συνδεδεμένη εταιρεία της PMI (π.χ. μέσω αγορών στην εκδήλωση ή μέσω αισθητήρων στον χώρο διεξαγωγής της εκδήλωσης που συνδέονται με τεχνολογία κινητής τηλεφωνία),
                  </li>
                  <li>
                    επικοινωνείτε μαζί μας (για παράδειγμα, μέσω ενός σημείου επαφής ή μέσω πλατφόρμων των μέσων κοινωνικής δικτύωσης),
                  </li>
                  <li>
                    χρησιμοποιείτε σημεία επαφής της PMI (π.χ. μέσω μηχανισμών παρακολούθησης σε μια εφαρμογή ή έναν ιστότοπο) ή
                  </li>
                  <li>
                    δημοσιεύετε αναρτήσεις σε πλατφόρμες των μέσων κοινωνικής δικτύωσης που παρακολουθούμε (για παράδειγμα, για να κατανοήσουμε την κοινή γνώμη ή να απαντήσουμε σε αιτήματα σχετικά με τα προϊόντα της PMI).
                  </li>
                </ul>
                <p>Μπορούμε επίσης να συλλέγουμε αυτόματα πληροφορίες σχετικά με εσάς μέσω της χρήσης cookies και παρόμοιων τεχνολογιών παρακολούθησης σε ψηφιακά σημεία επαφής της PMI. Τα συγκεκριμένα cookies και οι τεχνολογίες που χρησιμοποιούνται εξαρτώνται από το εκάστοτε σημείο επαφής της PMI. Για να μάθετε σχετικά με τα cookies (συμπεριλαμβανομένων των Google Analytics cookies) και τις παρόμοιες τεχνολογίες που χρησιμοποιούνται σε ένα σημείο επαφής, συμπεριλαμβανομένου του τρόπου με τον οποίο μπορείτε να αποδεχτείτε ή να απορρίψετε τα cookies, ανατρέξτε στη δήλωση σχετικά με τα cookies που είναι διαθέσιμη στο εκάστοτε σημείο επαφής.</p>
                <p>Εφόσον επιτρέπεται από τον νόμο, ενδέχεται να λάβουμε πληροφορίες σχετικά με εσάς από τρίτους. Αυτές μπορεί να περιλαμβάνουν πληροφορίες που διαβιβάζονται μεταξύ των συνδεδεμένων εταιρειών της PMI, δημοσιευμένες πληροφορίες προφίλ (όπως οι προτιμήσεις και τα ενδιαφέροντα σας) σε ιστότοπους μέσων κοινωνικής δικτύωσης τρίτων (όπως Facebook και Twitter) και λίστες εμπορικής προώθησης που έχουν αποκτηθεί από γραφεία εμπορικής προώθησης .</p>
                <p>Ενδέχεται επίσης να συλλέξουμε πληροφορίες σε άλλες περιπτώσεις για τις οποίες θα σας ενημερώσουμε κατά τον εκάστοτε χρόνο.</p>
                <h4><a id="a__Τι_πληροφορίες_συλλέγουμε_"></a>Τι πληροφορίες συλλέγουμε;</h4>
                <p>Μπορούμε να συλλέξουμε διάφορους τύπους πληροφοριών για εσάς:</p>
                <ul>
                  <li>
                    πληροφορίες που είναι απαραίτητες για την εκτέλεση των παραγγελιών σας
                  </li>
                  <li>
                    πληροφορίες που είναι απαραίτητες για την παροχή υπηρεσιών εγγύησης
                  </li>
                  <li>
                    πληροφορίες που μας παρέχετε σε φόρμες ή έρευνες
                  </li>
                  <li>
                    πληροφορίες σχετικά με τις επισκέψεις σας στα καταστήματα και τις εκδηλώσεις μας
                  </li>
                  <li>
                    πληροφορίες που μας παρέχετε κατά τη διάρκεια κλήσεων στα τηλεφωνικά μας κέντρα
                  </li>
                  <li>
                    πληροφορίες σχετικά με τις προτιμήσεις και τα ενδιαφέροντά σας
                  </li>
                  <li>πληροφορίες που είναι απαραίτητες για την επαλήθευση της ηλικίας σας </li>
                </ul>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Οι πληροφορίες που συλλέγουμε απευθείας από εσάς θα προσδιορίζονται κατά περίπτωση ανάλογα με το πλαίσιο στο οποίο δηλώνονται. Για παράδειγμα:</p>
                <ul>
                  <li>
                    εάν παραγγείλετε ένα προϊόν από εμάς μέσω ενός σημείου επαφής, δηλώνετε το όνομα, την επαφή, τα στοιχεία χρέωσης και τα προϊόντα που έχετε επιλέξει ώστε να μπορέσουμε να εκτελέσουμε την παραγγελία σας,
                  </li>
                </ul>
                <ul>
                  <li>
                    μπορείτε να δηλώσετε πληροφορίες σχετικά με τις προτιμήσεις προϊόντων και τα ενδιαφέροντά σας, ώστε να μπορούμε να σας προσφέρουμε προϊόντα και υπηρεσίες που θα σας ενδιαφέρουν,
                  </li>
                  <li>εάν κλείσετε ραντεβού για να μας συναντήσετε (ή κάποιον που παρέχει υπηρεσίες για τα προϊόντα ή τις υπηρεσίες μας), ενδεχομένως να συλλέξουμε το όνομα και τα στοιχεία επικοινωνίας σας, </li>
                  <li>ενδέχεται να συλλέξουμε πληροφορίες που μας επιτρέπουν να επαληθεύσουμε την ηλικία σας, για παράδειγμα αντίγραφο της ταυτότητας ή την εικόνα του προσώπου σας.</li>
                </ul>
                <p>Οι πληροφορίες που συλλέγουμε αυτόματα θα αφορούν γενικά σε:</p>
                <ul>
                  <li>
                    λεπτομέρειες σχετικά με την επίσκεψή σας ή την κλήση σας (όπως χρόνο και διάρκεια),
                  </li>
                  <li>
                    σε ένα κατάστημα πωλήσεων ή σε μια εκδήλωση (συμπεριλαμβανομένων των περιοχών που βρίσκονται σε άμεση γειτνίαση), πόσο συχνά τα επισκέπτεστε, ποιους χώρους επισκέπτεστε και για πόσο χρόνο και ποιες αγορές κάνετε,
                  </li>
                  <li>
                    τη χρήση που κάνετε στα ψηφιακά μέσα επαφής της PMI (όπως οι σελίδες που επισκέπτεστε, η σελίδα από την οποία συνδεθήκατε και η σελίδα στην οποία μεταβήκατε όταν φύγατε, οι όροι αναζήτησης που έχετε εισαγάγει ή οι σύνδεσμοι στους οποίους κάνατε κλικ μέσα από το σημείο επαφής) και
                  </li>
                  <li>
                    τη συσκευή σας (όπως η διεύθυνση IP ή το μοναδικό αναγνωριστικό συσκευής, τα δεδομένα τοποθεσίας, λεπτομέρειες σχετικά με τυχόν cookies που ενδέχεται να έχουμε αποθηκεύσει στη συσκευή σας).
                  </li>
                </ul>
                <p>Οι πληροφορίες που συλλέγουμε από τρίτους θα αποτελούν γενικά δημοσιευμένες πληροφορίες προφίλ (όπως οι προτιμήσεις και τα ενδιαφέροντά σας), για παράδειγμα από δημόσιες αναρτήσεις στα μέσα κοινωνικής δικτύωσης.</p>
                <h4><a id="a__Για_ποιους_σκοπούς_χρησιμοποιούμε_πληροφορίες_σχετικά_με_εσάς_και_με_ποια_νομική_βάση_"></a>Για ποιους σκοπούς χρησιμοποιούμε πληροφορίες σχετικά με εσάς και με ποια νομική βάση;</h4><p>Σε αυτή την ενότητα περιγράφουμε τους σκοπούς για τους οποίους χρησιμοποιούμε προσωπικά δεδομένα. Ωστόσο, η παρούσα δήλωση αφορά στην δραστηριότητά μας παγκοσμίως και όταν οι νόμοι μιας χώρας περιορίζουν ή απαγορεύουν ορισμένες δραστηριότητες που περιγράφονται στην παρούσα δήλωση, δεν θα χρησιμοποιήσουμε προσωπικές σας πληροφορίες για τους σκοπούς αυτούς στη συγκεκριμένη χώρα.</p>
                <p>Με την επιφύλαξη των ανωτέρω, χρησιμοποιούμε πληροφορίες σχετικά με εσάς για τους ακόλουθους σκοπούς:</p>
                <ul>
                  <li>
                    για τη συμμόρφωση με τις κανονιστικές υποχρεώσεις, όπως η επαλήθευση της ηλικίας σας και του καθεστώτος σας ως χρήστη των προϊόντων μας,
                  </li>
                  <li>
                    στο πλαίσιο πώλησης των προϊόντων μας σε εσάς, όπως για τη διεκπεραίωση των παραγγελιών σας και την επεξεργασία των πληρωμών σας
                  </li>
                  <li>
                    στο πλαίσιο παροχής υπηρεσιών σε εσάς σχετικά με τις πωλήσεις, όπως για τη διεκπεραίωση των αιτημάτων σας και την απάντηση σε τυχόν ερωτήματά σας, καθώς και για την παροχή υπηρεσιών εγγύησης
                  </li>
                  <li>για τη εμπορική προώθηση των προϊόντων μας (όπου επιτρέπεται από τον νόμο), μεταξύ άλλων για τη διαχείριση των προγραμμάτων επιβράβευσης πελατών, τη βελτίωση των προϊόντων, έρευνες αγοράς, την ανάπτυξη στρατηγικών εμπορικής προώθησης και τη διαχείριση εκστρατειών εμπορικής προώθησης, καθώς και για την εξατομίκευση των εμπειριών σας σε καταστήματα που πωλούν προϊόντα PMI και σε εκδηλώσεις, </li>
                  <li>για να σας ενημερώνουμε εμείς ή οι συνεργάτες μας για πιθανές ευκαιρίες συμμετοχής στις πρωτοβουλίες εμπορικής προώθησης ή προώθησης προϊόντων της PMI </li>
                  <li>για την υποστήριξη όλων των ανωτέρω, μεταξύ άλλων για τη διαχείριση των λογαριασμών σας, τη δυνατότητα να χρησιμοποιείτε τα σημεία επαφής PMI, την επικοινωνία μαζί σας, τη διαχείριση των ραντεβού που έχετε κλείσει μαζί μας ή με όποιον υποστηρίζει τα προϊόντα ή τις υπηρεσίες μας (για παράδειγμα, όσον αφορά ένα νέο προϊόν ή μια υπηρεσία μετά την πώληση), την εξατομίκευση της εμπειρίας σας με τα σημεία επαφής της PMI, καθώς και τη διαχείριση και την αντιμετώπιση προβλημάτων, </li>
                  <li>για αναλύσεις επιχειρηματικών πληροφοριών και βελτιώσεις, όπως για τη βελτίωση των προϊόντων, των καταστημάτων και των εκδηλώσεων της PMI καθώς και των πληροφοριών που εμείς (ή οι συνδεδεμένες εταιρείες μας) παρέχουμε στους πελάτες μας, </li>
                  <li>για άλλους σκοπούς για τους οποίους θα σας ενημερώνουμε ,  ή θα προσδιορίζονται κατά περίπτωση, στο αρχικό σημείο συλλογής πληροφοριών για εσάς </li>
                </ul>
                <p>Η νομική βάση για τη χρήση των πληροφοριών σχετικά με εσάς είναι μία από τις ακόλουθες (παρέχουμε λεπτομερέστερες εξηγήσεις στην ενότητα «μάθετε περισσότερα»):</p>
                <ul>
                  <li>
                    η τήρηση έννομης υποχρέωσης με την οποία δεσμευόμαστε,
                  </li>
                  <li>
                    η εκτέλεση μιας σύμβασης στην οποία είστε συμβαλλόμενο μέρος,
                  </li>
                  <li>
                    το έννομο επιχειρηματικό συμφέρον έναντι του οποίου δεν υπερισχύουν τα συμφέροντα που έχετε για την προστασία των πληροφοριών,
                  </li>
                  <li>
                    αν δεν ισχύει κανένα από τα παραπάνω, η συγκατάθεσή σας (την οποία θα ζητήσουμε πριν επεξεργαστούμε τις πληροφορίες).
                  </li>
                </ul>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Οι σκοποί για τους οποίους χρησιμοποιούμε τις πληροφορίες σχετικά με εσάς, με τις αντίστοιχες μεθόδους συλλογής και τη νομική βάση για τη χρήση τους, είναι οι εξής:</p>
                <table>
                  <thead>
                  <tr>
                    <th scope="col"><b>Σκοπός</b></th>
                    <th scope="col"><b>  Μέθοδος συλλογής και νομική βάση για την επεξεργασία</b></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td data-label="Σκοπός"><br>Συμμόρφωση με τις κανονιστικές υποχρεώσεις:
                      <ul>
                        <li> επαλήθευση της ηλικίας σας, καθώς και του καθεστώτος σας ως χρήστη των προϊόντων μας</li>
                      </ul>
                    </td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Αυτές οι πληροφορίες παρέχονται γενικά σε εμάς απευθείας από εσάς.Τις χρησιμοποιούμε επειδή είναι απαραίτητες για εμάς προκειμένου να συμμορφωθούμε με την εκ του νόου υποχρέωση να πωλούμε προϊόντα μόνο σε ενήλικες ή σε χώρες όπου δεν υφίσταται η εν λόγω εκ του ν’ομου υποχρέωση, επειδή έχουμε το έννομο επιχειρηματικό συμφέρον να πωλούμε τα προϊόντα μας μόνο σε ενήλικες, έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και οι ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών.
                    </td>

                  </tr>
                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Πώληση των προϊόντων μας:
                      <ul>
                        <li>εκτέλεση των παραγγελιών σας (συμπεριλαμβανομένης της αποστολής αποδείξεων)</li>
                        <li>τη διεκπεραίωση των πληρωμών σας</li>
                        <li>την παροχή υπηρεσιών εγγύησης</li> </ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Οι εν λόγω πληροφορίες παρέχονται γενικά σε εμάς από απευθείας από εσάς (συνήθως ονοματεπώνυμο, διεύθυνση, διεύθυνση e-mail, στοιχεία πληρωμής).Τις χρησιμοποιούμε για την εκπλήρωση των συμβατικών μας υποχρεώσεων προς εσάς ως αγοραστή των προϊόντων μας.
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Παροχή υπηρεσιών σχετικών με τις πωλήσεις:
                      <ul>
                        <li>απάντηση σε ερωτάματα και σε αιτήματα σας</li>
                        <li>αλληλογραφία με εσάς</li>
                        <li>γενική διαχείριση και αντιμετώπιση προβλημάτων</li>
                        <li>διαχείριση προγραμμάτων επιβράβευσης πελατών</li></ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Αυτές οι πληροφορίες παρέχονται γενικά σε εμάς απευθείας από εσάς.Τις χρησιμοποιούμε επειδή έχουμε έννομο επιχειρηματικό συμφέρον όσον αφορά την παροχή υπηρεσιών σχετικά με τις πωλήσεις στους πελάτες μας, έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και οι ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Εμπορική προώθηση των προϊόντων μας (όπου επιτρέπεται βάσει νόμου):
                      <ul>
                        <li>κατανόηση των προτιμήσεών σας (όπως ποια προϊόντα ή εκδηλώσεις μπορεί να σας ενδιαφέρουν ή ποια είναι καλύτερα προσαρμοσμένα στις ανάγκες σας) και, όπου επιτρέπεται βάσει νόμου, προώθηση προϊόντων σε εσάς προσωπικά</li>
                        <li>διαχείριση προγραμμάτων επιβράβευσης πελατών</li>
                        <li>πρόσκλησή σας για συμμετοχή σε έρευνες ή εκστρατείες έρευνας αγοράς και διαχείριση αυτών</li>
                        <li>έρευνα αγοράς</li>
                        <li>ανάπτυξη στρατηγικών μάρκετινγκ</li>
                        <li>διαχείριση εκστρατειών προώθησηςπροϊόντων στην αγορά</li>
                        <li>εξατομίκευση της εμπειρίας σας με τα σημεία επαφής της PMI (για παράδειγμα, εξατομίκευση της επίσκεψής σας, όπως με χαιρετισμούς ή προτάσεις που μπορεί να σας ενδιαφέρουν)</li>
                      </ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία">Τα εν λόγω στοιχεία αποτελούν συνήθως έναν συνδυασμό πληροφοριών που εσείς μας παρέχετε (για παράδειγμα, το ονοματεπώνυμο και τα στοιχεία επικοινωνίας σας, καθώς και τα στοιχεία σας στα μέσα κοινωνικής δικτύωσης), πληροφορίες που συλλέγουμε αυτόματα (για παράδειγμα, με την εφαρμογή της τεχνολογίας για την παρακολούθηση της χρήσης των σημείων επαφής της PMI) και (όπου αυτό επιτρέπεται βάσει νόμου) πληροφορίες που αποκτούμε από τρίτα μέρη (όπως δημοσιεύσεις σε μέσα κοινωνικής δικτύωσης). Τις χρησιμοποιούμε καθότι έχουμε το έννομο επιχειρηματικό συμφέρον να προωθούμε εμπορικά τα προϊόντα μας στην αγορά, να λειτουργούμε τα σημεία επαφής της PMI και να εξατομικεύουμε τις εμπειρίες σας έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και τις ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Εμπορική προώθηση των προϊόντων μας (όπου επιτρέπεται βάσει νόμου):
                      <ul>
                        <li>να σας παρέχουμε πληροφορίες σχετικά με, καθώς και να διαχειριζόμαστε, τις συνδεδεμένες εταιρείες της PMI, τις προωθητικές τους ενέργειες, τα προϊόντα και τις υπηρεσίες τους, τα καταστήματα λιανικής πώλησης, τις εκδηλώσεις και τη ρύθμιση των προϊόντων μας και να σχεδιάζουμε και να πραγματοποιούμε βελτιώσεις σε εργαλεία για την επίτευξη των εν λόγω σκοπών</li></ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Τα εν λόγω στοιχεία αποτελούν συνήθως έναν συνδυασμό πληροφοριών που εσείς μας παρέχετε (για παράδειγμα, το ονοματεπώνυμο και τα στοιχεία επικοινωνίας σας, καθώς και τα στοιχεία σας στα μέσα κοινωνικής δικτύωσης), πληροφορίες που συλλέγουμε αυτόματα (για παράδειγμα, με τη χρήση cookies και παρόμοιων τεχνολογιών) και (όπου αυτό επιτρέπεται βάσει νόμου) πληροφορίες που αποκτούμε από τρίτα μέρη (όπως δημοσιεύσεις σε μέσα κοινωνικής δικτύωσης). Τις χρησιμοποιούμε επειδή έχουμε έννομο επιχειρηματικό συμφέρον να τα διαθέτουμε στην αγορά, έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και οι ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών. Σε ορισμένες χώρες, όπου απαιτείται βάσει νόμου, θα σας αποστέλλουμε το εν λόγω υλικό σε ηλεκτρονική μορφή με τη συγκατάθεσή σας μόνο.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Υποστήριξη για όλους τους ανωτέρω σκοπούς:
                      <ul>
                        <li>διαχείριση των λογαριασμών σας</li>
                        <li>παροχή δυνατότητας να χρησιμοποιείτε τα σημεία επαφής της PMI (για παράδειγμα, δυνατότητα να παραμείνετε συνδεδεμένοι σε τμήματα ενός σημείου επαφής που προορίζονται αποκλειστικά για εξουσιοδοτημένους χρήστες, διαχείριση της προτίμησης γλώσσας, σύνδεση του καλαθιού αγορών σας με εσάς)</li>
                        <li>αλληλογραφία με εσάς</li>
                        <li>διαχείριση των ραντεβού που έχετε κλείσει μαζί μας ή με όποιον παρέχει υπηρεσίες για τα προϊόντα ή τις υπηρεσίες μας (για παράδειγμα, όσον αφορά ένα νέο προϊόν ή μια υπηρεσία μετά την πώληση)</li>
                        <li>βελτίωση των εμπειριών σας</li>
                        <li>διαχείριση και αντιμετώπιση προβλημάτων</li></ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Τα εν λόγω στοιχεία αποτελούν συνήθως έναν συνδυασμό πληροφοριών που μας παρέχετε (συνήθως όνομα, κωδικό πρόσβασης ή αντίστοιχο) και των πληροφοριών που συλλέγουμε αυτόματα (για παράδειγμα, πληροφορίες σχετικά με τη συσκευή σας και cookies και παρόμοιες τεχνολογίες παρακολούθησης).Τις χρησιμοποιούμε επειδή ανταποκρίνονται στον σκοπό της χρήσης πληροφοριών που υποστηρίζουμε. Για παράδειγμα, όταν διαχειριζόμαστε τον λογαριασμό σας για να σας παράσχουμε υποστήριξη για μια αγορά ή υπηρεσία μετά την πώληση, χρησιμοποιούμε τις πληροφορίες για την εκπλήρωση των συμβατικών μας υποχρεώσεων σε εσάς ως αγοραστής των προϊόντων μας. Στην περίπτωση που διαχειριζόμαστε τον λογαριασμό σας για να σας παρουσιάσουμε τα προϊόντα μας, εκτελούμε εμπορική προώθηση, συνεπώς χρησιμοποιούμε τις σχετικές πληροφορίες καθότι έχουμε έννομο συμφέρον να προωθούμε τα προϊόντα μας, έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και οι ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών και ούτω καθεξής.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Σκοπός"><br>Επιχειρηματικές αναλύσεις και βελτιώσεις:
                      <ul>
                        <li>επιτρέπει σε εμάς ή τους επιχειρηματικούς μας συνεργάτες να σας ενημερώνουμε σχετικά με τις πιθανές δυνατότητες συμμετοχής σας στην προώθηση προϊόντων της PMI,</li>
                        <li>για επιχειρηματικές αναλύσεις και βελτιώσεις (μεταξύ άλλων εκείνων για προϊόντα της PMI, για καταστήματα που πωλούν προϊόντα της PMI, για εκδηλώσεις, για ψηφιακά σημεία επαφής της PMI και για τις πληροφορίες που εμείς (ή οι συνδεδεμένες εταιρείες μας) παρέχουμε στους πελάτες μας).</li> </ul></td>
                    <td data-label="Μέθοδος συλλογής και νομική βάση για την επεξεργασία"><br>Τα εν λόγω στοιχεία αποτελούν συνήθως έναν συνδυασμό των πληροφοριών που μας παρέχετε, των πληροφοριών που συλλέγουμε αυτόματα και των πληροφοριών που αποκτούμε από τρίτα μέρη (όπου αυτό επιτρέπεται βάσει νόμου). Τις χρησιμοποιούμε καθότι έχουμε έννομο επιχειρηματικό συμφέρον να αναλύσουμε και να βελτιώσουμε την επιχειρηματική μας απόδοση, τα προϊόντα μας, τα σημεία επαφής της PMI, τα καταστήματα και τις εκδηλώσεις, καθώς και να καλέσουμε άλλους να συμμετάσχουν στην προώθηση των προϊόντων της PMI, έναντι του οποίου δεν υπερισχύουν τα συμφέροντα, τα δικαιώματα και οι ελευθερίες σας όσον αφορά την προστασία των προσωπικών σας πληροφοριών.
                    </td>
                  </tr>

                  </tbody>
                </table>

                <p>Σε περίπτωση που η χρήση από εμάς των πληροφοριών που σας αφορούν δεν βασίζεται σε κάποια από τις παραπάνω νομικές βάσεις, θα ζητήσουμε τη συγκατάθεσή σας πριν επεξεργαστούμε τις πληροφορίες (οι περιπτώσεις αυτές θα προσδιορίζονται κατά περίπτωση).</p>
                <p>Σε ορισμένες περιπτώσεις, ενδέχεται να χρησιμοποιήσουμε πληροφορίες που σας αφορούν με τρόπους που δεν περιγράφονται παραπάνω. Εάν συμβεί αυτό, θα αποστείλουμε συμπληρωματική δήλωση προστασίας απορρήτου που εξηγεί τη χρήση αυτή. Θα πρέπει να διαβάζετε οποιαδήποτε συμπληρωματική δήλωση σε συνδυασμό με την παρούσα δήλωση.</p>
                <h4><a id="a__Σε_ποιον_διαβιβάζουμε_τις_πληροφορίες_σας_και_για_ποιους_σκοπούς_"></a>Σε  ποιον διαβιβάζουμε τις πληροφορίες σας και για ποιους σκοπούς;</h4>
                <p>Ενδεχεται να κοινοποιήσουμε τις πληροφορίες σας στους εξής:</p>
                <ul>
                  <li>
                    στις συνδεδεμένες εταιρείες της PMI,
                  </li>
                  <li>
                    σε τρίτα μέρη που παρέχουν στις συνδεδεμένες εταιρείες της PMI ή σε εσάς προϊόντα ή υπηρεσίες,
                  </li>
                  <li>
                    σε προσεκτικά επιλεγμένους επιχειρηματικούς συνεργάτες και διαφημιστές των συνδεδεμένων εταιρειών της PMI (σε τομείς που σχετίζονται με τα προϊόντα μας ή συμβαδίζουν με το ύφος και την εικόνα τους) έτσι ώστε να μπορούν σας ενημερώνουν για προσφορές που θεωρούν ότι ίσως σας ενδιαφέρουν σύμφωνα με τις προτιμήσεις σας και
                  </li>
                  <li>
                    σε άλλα τρίτα μέρη, όπου απαιτείται ή επιτρέπεται βάσει νόμου
                  </li>
                </ul>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Κοινή χρήση δεδομένων με άλλες συνδεδεμένες εταιρείες της PMI</p>
                <ul>
                  <li>
                    Οι πληροφορίες σας θα διαβιβάζονται στην Philip Morris International Management SA (με έδρα τη Λωζάνη, Ελβετία), όπου πραγματοποιείται η κεντρική διαχείριση της επεξεργασίας των δεδομένων προσωπικού χαρακτήρα για τις συνδεδεμένες εταιρείες της PMI. Η Philip Morris International Management SA επεξεργάζεται τις πληροφορίες σας για όλους τους σκοπούς που περιγράφονται στην παρούσα δήλωση.
                  </li>
                  <li>
                    Οι πληροφορίες σας μπορεί να διαβιβαστούν σε συνδεδεμένη εταιρεία της PMI που είναι υπεύθυνη για τη χώρα στην οποία διαμένετε (αν δεν ήταν η συνδεδεμένη εταιρεία της PMI που συνέλεξε αρχικά τις πληροφορίες) για όλους τους σκοπούς που περιγράφονται στην παρούσα δήλωση.</li>
                  <li>Οι πληροφορίες σας μπορεί να διαβιβαστούν σε οποιαδήποτε άλλη συνδεδεμένη εταιρεία της PMI με την οποία επικοινωνείτε (για παράδειγμα, εάν ταξιδεύετε και θέλετε να μάθετε πού να αγοράσετε προϊόντα της PMI σε μια νέα χώρα ή πού να βρείτε υπηρεσίες ή υποστήριξη για προϊόντα της PMI) προκειμένου να βeλτιώσουμε την παροχή υπηρεσιών σε σάς.
                  </li>
                </ul>
                <p>Λεπτομέρειες σχετικά με τις συνδεδεμένες εταιρείες της PMI και τις χώρες στις οποίες είναι εγκατεστημένες διατίθενται <a href="https://www.pmi.com">εδώ</a>.</p>
                <p>Κοινή χρήση δεδομένων με τρίτους</p>
                <ul>
                  <li>
                    Ενδέχεται να αποκαλύψουμε πληροφορίες σας σε τρίτους που παρέχουν σε συνδεδεμένες εταιρείες της PMI ή σε εσάς προϊόντα ή υπηρεσίες (όπως σε συμβούλους, παρόχους υπηρεσιών πληρωμών, παρόχους υπηρεσιών παράδοσης, καταστήματα λιανικής, εκπαιδευτές νέων προϊόντων, παρόχους υπηρεσιών πληροφορικής και παρόχους επαλήθευσης ηλικίας).
                  </li>
                  <li>
                    Ενδέχεται να γνωστοποιήσουμε τις πληροφορίες σας σε προσεκτικά επιλεγμένους τρίτους συνεργάτες και διαφημιστές των συνδεδεμένων εταιρειών της PMI (σύμφωνα με το είδος του αντικειμένου που μπορείτε να συσχετίσετε με τα προϊόντα μας, για παράδειγμα, επειδή έχουν παρόμοια ή συμπληρωματική εικόνα, στυλ ή λειτουργικές δυνατότητες), ώστε να μπορούν να επικοινωνήσουν μαζί σας για προϊόντα, υπηρεσίες και προωθητικές ενέργειες που πιστεύουν ότι μπορεί να σας ενδιαφέρουν, ανάλογα με τις προτιμήσεις σας.
                  </li>
                  <li>
                    Ενδέχεται να αποκαλύψουμε τις πληροφορίες σας σε άλλα τρίτα μέρη, εφόσον απαιτείται ή επιτρέπεται από τον νόμο, για παράδειγμα: ρυθμιστικές αρχές, δημόσια διοίκηση· κατόπιν αιτήματος των αρχών επιβολής του νόμου ή άλλων κρατικών υπαλλήλων· όταν θεωρούμε ότι η γνωστοποίησή τους είναι απαραίτητη ή κατάλληλη για την πρόληψη σωματικής βλάβης ή οικονομικής ζημίας ή σε σχέση με έρευνες σχετικά με πιθανολογούμενη ή πραγματική παράνομη δραστηριότητα, καθώς και στο πλαίσιο οργανωτικής αναδιάρθρωσης.
                  </li>
                </ul>
                <h4><a id="a__Πού_ενδέχεται_να_σταλούν_οι_πληροφορίες_που_σας_αφορούν_"></a>Πού ενδέχεται να σταλούν οι πληροφορίες που σας αφορούν;</h4>
                <p>Όπως συμβαίνει με κάθε πολυεθνική εταιρεία, οι συνδεδεμένες εταιρείες της PMI διαβιβάζουν πληροφορίες παγκοσμίως. Κατά συνέπεια, οι πληροφορίες σας ενδέχεται να διαβιβαστούν σε παγκόσμιο επίπεδο (αν οι πληροφορίες σας συλλέγονται εντός του Ευρωπαϊκού Οικονομικού Χώρου, αυτό σημαίνει ότι ενδέχεται να διαβιβαστούν και εκτός αυτού).</p>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Κατά τη χρήση πληροφοριών, όπως περιγράφονται στην παρούσα δήλωση, οι πληροφορίες που σας αφορούν ενδέχεται να διαβιβαστούν είτε εντός είτε εκτός της χώρας ή της επικράτειας όπου συλλέχθηκαν, συμπεριλαμβανομένης μιας χώρας ή επικράτειας που ενδέχεται να μην έχει ισοδύναμους κανόνες προστασίας των δεδομένων.</p>
                <p>Για παράδειγμα, οι συνδεδεμένες εταιρείες της PMI εντός του Ευρωπαϊκού Οικονομικού Χώρου («ΕΟΧ») δύνανται να διαβιβάζουν προσωπικές πληροφορίες σε συνδεδεμένες εταιρείες της PMI εκτός του ΕΟΧ. Σε κάθε περίπτωση, η διαβίβαση θα πραγματοποιείται ως εξής:</p>
                <ul>
                  <li>
                    βάσει <a href="http://ec.europa.eu/justice/data-protection/international-transfers/adequacy/index_en.htm">απόφασης περί επάρκειας της Ευρωπαϊκής Επιτροπής</a>·
                  </li>
                  <li>
                    με την επιφύλαξη των κατάλληλων εγγυήσεων, όπως για παράδειγμα τα οι Τυποποιημένες Ρήτρες προστασίας δεδομένων (EU Model Clauses) ή
                  </li>
                  <li>
                    στον βαθμό που είναι αναγκαίο για την εκτέλεση των υποχρεώσεων στο πλαίσιο σύμβασης που έχει συναφθεί μεταξύ μας (ή για την εφαρμογή των προσυμβατικών μέτρων που ελήφθησαν κατόπιν αιτήματός σας) ή για τη σύναψη ή την εκτέλεση σύμβασης που συνάπτεται προς το συμφέρον σας ανάμεσα σε εμάς και τρίτους, όπως όσον αφορά τη διοργάνωση ταξιδιού.
                  </li>
                </ul>
                Σε κάθε περίπτωση, θα εφαρμόζονται τα κατάλληλα μέτρα ασφαλείας για την προστασία των προσωπικών δεδομένων σε αυτές τις χώρες ή επικράτειες, σύμφωνα με τους ισχύοντες νόμους περί προστασίας δεδομένων.
                <br>
                <h4><a id="a__Πώς_προστατεύουμε_τις_πληροφορίες_που_σας_αφορούν_"></a>Πώς προστατεύουμε τις πληροφορίες που σας αφορούν;</h4>
                <p>Εφαρμόζουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των προσωπικών πληροφοριών που διατηρούμε απέναντι σε κάθε άνευ αδείας κοινοποίηση χρήση, μεταβολή ή καταστροφή. Κατά περίπτωση, χρησιμοποιούμε κρυπτογράφηση και άλλες τεχνολογίες που μπορούν να συμβάλουν στην ασφάλεια των πληροφοριών που παρέχετε. Ζητούμε επίσης από τους παρόχους υπηρεσιών μας να συμμορφώνονται με τις αυστηρές απαιτήσεις περί προστασίας και ασφάλειας των προσωπικών δεδομένων .</p>
                <h4><a id="a__Πόσο_καιρό_θα_διατηρηθούν_οι_πληροφορίες_που_σας_αφορούν_"></a>Πόσο καιρό θα διατηρηθούν οι πληροφορίες που σας αφορούν;</h4>
                <p>Θα διατηρήσουμε τις πληροφορίες που σας αφορούν για το χρονικό διάστημα που είναι απαραίτητο για την εκπλήρωση των σκοπών για τους οποίους συλλέχθηκαν. Μετά το πέρας του εν λόγω χρονικού διαστήματος, θα τις διαγράψουμε. Το χρονικό διάστημα θα ποικίλλει ανάλογα με τους σκοπούς για τους οποίους συλλέχθηκαν οι πληροφορίες. Να σημειωθεί ότι, σε ορισμένες περιπτώσεις, έχετε το δικαίωμα να μας ζητήσετε να διαγράψουμε τις πληροφορίες. Επίσης, ορισμένες φορές υποχρεούμαστε βάσει νόμου να διατηρήσουμε τις πληροφορίες, για παράδειγμα, για φορολογικούς και λογιστικούς σκοπούς.</p>
                <h4><a id="a__Μάθετε_περισσότερα…"></a>Μάθετε περισσότερα…</h4>
                <p>Συνήθως διατηρούμε τα δεδομένα βάσει των κριτηρίων που περιγράφονται στον παρακάτω πίνακα:</p>
                <table>
                  <thead>
                  <tr>
                    <th scope="col"><b>Τύπος</b></th>
                    <th scope="col"><b>Επεξήγηση/τυπικά κριτήρια διατήρησης
                    </b></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td data-label="Τύπος"><br>
                      <ul>
                        <li>ενέργειες εμπορικής προώθησης προς εσάς (συμπεριλαμβανομένων των εμπορικών επικοινωνιών) (εάν χρησιμοποιείτε ψηφιακά σημεία επαφής και υποστηρίζουν τη δυνατότητα επικοινωνίας)</li>
                      </ul>
                    </td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Οι περισσότερες από τις πληροφορίες που περιέχονται στο προφίλ εμπορικής προώθησης διατηρούνται για όλη τη διάρκεια της προωθητικής σχέσης σας, για παράδειγμα, για όσο διάστημα συνεχίζετε να χρησιμοποιείτε ψηφιακά σημεία επαφής ή να ανταποκρίνεστε στις ανακοινώσεις μας. Ωστόσο, ορισμένα στοιχεία του προφίλ προώθησης σας, όπως αρχεία σχετικά με τον τρόπο που αλληλεπιδρούμε μαζί σας, είναι φυσικό να παύουν να ισχύουν έπειτα από μια χρονική περίοδο, οπότε τα διαγράφουμε αυτόματα έπειτα από έναν καθορισμένο διάστημα (συνήθως 3 έτη) ανάλογα με τον σκοπό για τον οποίο τα συλλέξαμε.
                    </td>

                  </tr>
                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>ενέργειες εμπορικής προώθησης προς εσάς (συμπεριλαμβανομένων των εμπορικών επικοινωνιών) (εάν δεν έχετε πλέον επικοινωνία μαζί μας)</li>
                      </ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Το εν λόγω σενάριο είναι το ίδιο με το παραπάνω, αλλά, αν δεν έχουμε καμία επικοινωνία μαζί σας για μεγάλο χρονικό διάστημα (συνήθως 2 έτη), τότε θα σταματήσουμε να σας αποστέλλουμε προωθητικές ανακοινώσεις και θα διαγράψουμε το ιστορικό των σχετικών απαντήσεών σας. Αυτό θα συμβεί, για παράδειγμα, αν δεν κάνετε ποτέ κλικ μέσα σε μια πρόσκληση για μια εκδήλωση, αν δεν συνδεθείτε ποτέ σε ένα ψηφιακό σημείο επαφής ή αν δεν επικοινωνήσετε ποτέ με την εξυπηρέτηση πελάτων κατά τη διάρκεια του εν λόγω διαστήματος. Ο λόγος είναι ότι, στις περιπτώσεις αυτές, υποθέτουμε ότι προτιμάτε να μην λαμβάνετε ανακοινώσεις.
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>ενέργειες εμπορικής προώθησης προς εσάς (συμπεριλαμβανομένων των εμπορικών επικοινωνιών) ((εάν δεν μπορούμε πλέον να επικοινωνήσουμε μαζί σας)</li></ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Εάν έχετε εγγραφεί να λαμβάνετε εμπορική επικοινωνία, αλλά οι πληροφορίες που μας έχετε δώσει για να επικοινωνούμε μαζί σας δεν ισχύουν, θα διατηρήσουμε τις πληροφορίες σας για ένα διάστημα συνήθως μόνο 6 μηνών, ώστε να σας δώσουμε το χρονικό περιθώριο να τις διορθώσετε.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>ενέργειες εμπορικής προώθησης προς εσάς (συμπεριλαμβανομένων των εμπορικών επικοινωνιώνν) (μη ολοκληρωμένες καταχωρίσεις)</li>
                      </ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Εάν ξεκινήσατε την καταχώρισή σας σε μια βάση δεδομένων, αλλά δεν ολοκληρώσατε τη διαδικασία (για παράδειγμα, εάν δεν ολοκληρώσατε τη διαδικασία επαλήθευσης της ηλικίας ή δεν αποδεχθήκατε τους όρους χρήσης του σημείου επαφής), θα φυλάξουμε τα στοιχεία σας μόνο για ένα διάστημα 6 μηνών προκειμένου να σας δώσουμε τη δυνατότητα να ολοκληρώσετε τη διαδικασία.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>έρευνα αγοράς</li></ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Αν δεν έχετε εγγραφεί σε εμάς για άλλους σκοπούς (π.χ. προωθητικές ενέργειες, εγγύηση, εξυπηρέτηση πελατών) και χρησιμοποιούμε δημοσιοποιημένες πληροφορίες σας προκειμένου να κατανοήσουμε την αγορά ή τις προτιμήσεις σας, θα διατηρήσουμε τις πληροφορίες σας για σύντομο χρονικό διάστημα, ώστε να ολοκληρώσουμε τον συγκεκριμένο τομέα της έρευνας αγοράς.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>αγορές και εγγύηση</li></ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Αν αγοράσετε προϊόντα, θα διατηρήσουμε τα στοιχεία της συναλλαγής σας για όσο διάστημα απαιτείται για την ολοκλήρωση της πώλησης και για να συμμορφωθούμε με οποιεσδήποτε νομικές υποχρεώσεις (για παράδειγμα, για φορολογικούς και λογιστικούς σκοπούς). Αν επίσης εγγραφείτε σε ένα πρόγραμμα εγγύησης για μια συσκευή, θα διατηρήσουμε τα στοιχεία εφόσον είναι σχετικά με την εγγύηση.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>Εξυπηρέτηση πελατών</li> </ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Αν επικοινωνήσετε με την εξυπηρέτηση πελατών, θα δημιουργηθεί σχετικό αρχείο (συμπεριλαμβανομένων των λεπτομερειών σχετικά με το ερώτημά σας και την απάντησή μας) και θα το διατηρήσουμε για όσο διάστημα παραμένει σχετικό με τη σχέση μας, για παράδειγμα, αν χρειαστείτε αντικατάσταση συσκευής που βρίσκεται σε εγγύηση ή εάν τα πρόσφατα ερωτήματά σας είναι σχετικά. Τα προσωρινά αρχεία (για παράδειγμα, αυτοματοποιημένη καταγραφή τηλεφωνικής κλήσης στην οποία μας ζητήσατε να σας παραπέμψουμε σε ένα κατάστημα λιανικής πώλησης) μπορεί να μην έχουν χρησιμότητα έως ότου δημιορυγηθούνπιο μόνιμα αρχεία και θα διατηρούνται μόνο προσωρινώς.
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>Αρχεία καταγραφής ελέγχων συστήματος</li> </ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Τα αρχεία καταγραφής ελέγχων συστήματος διατηρούνται συνήθως για περίοδο μόνο μερικών μηνών.</td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Τύπος"><br>
                      <ul>
                        <li>Επιχειρηματικές αναλύσεις</li> </ul></td>
                    <td data-label="Επεξήγηση/τυπικά κριτήρια διατήρησης"><br>Τα δεδομένα επιχειρηματικών αναλύσεων συλλέγονται συνήθως αυτόματα όταν χρησιμοποιείτε σημεία επαφής της PMI και ανωνυμοποιούνται/ομαδοποιούνται συγκεντρωτικά άμεσα.
                    </td>
                  </tr>
                  </tbody>
                </table>
                <br>
                <h>Τι δικαιώματα και επιλογές έχετε;</h>
                <p>Μπορεί να έχετε ορισμένα ή όλα τα ακόλουθα δικαιώματα όσον αφορά προσωπικά δεδομένα σχετικά με εσάς που τηρούμε:</p>
                <ul>
                  <li>
                    να μας ζητήσετε να αποκτήσετε πρόσβαση σε αυτά,
                  </li>
                  <li>
                    να μας ζητήσετε να τα διορθώσουμε, να τα ενημερώσουμε ή να τα διαγράψουμε,
                  </li>
                  <li>
                    να μας ζητήσετε να περιορίσουμε τη χρήση τους, υπό ορισμένες συνθήκες,
                  </li>
                  <li>
                    να εναντιωθείτε στη χρήση τους, υπό ορισμένες συνθήκες,
                  </li>
                  <li>
                    να ανακαλέσετε τη συγκατάθεσή σας όσον αφορά τη χρήση τους,
                  </li>
                  <li>
                    να ασκήσετε το δικαίωμα στη φορητότητα των δεδομένων, υπό ορισμένες συνθήκες,
                  </li>
                  <li>
                    να διαγραφείτε από οποιαδήποτε εμπορική επικοινωνία και
                  </li>
                  <li>
                    να υποβάλετε καταγγελία στην εποπτική αρχή της χώρας σας (εάν υπάρχει).
                  </li>
                </ul>
                <p>Σας προσφέρουμε εύκολους τρόπους να ασκήσετε τα εν λόγω δικαιώματα, όπως συνδέσμους «κατάργησης εγγραφής» ή δίνοντάς σας μια διεύθυνση επικοινωνίας στα μηνύματα που λαμβάνετε.</p>
                <p>Ορισμένες εφαρμογές για κινητά που προσφέρουμε μπορεί επίσης να σας στέλνουν αυτόκλητα μηνύματα σχετικά, για παράδειγμα, με νέα προϊόντα ή υπηρεσίες. Μπορείτε να απενεργοποιήσετε αυτά τα μηνύματα μέσω των ρυθμίσεων στο τηλέφωνό σας ή στην εφαρμογή.</p>
                <h4>Μάθετε περισσότερα…</h4>
                <p>Τα δικαιώματα που έχετε εξαρτώνται από τους νόμους της χώρας σας. Εάν βρίσκεστε στον Ευρωπαϊκό Οικονομικό Χώρο, θα έχετε τα δικαιώματα που αναφέρονται στον παρακάτω πίνακα. Αν βρίσκεστε αλλού, μπορείτε να επικοινωνήσετε μαζί μας (ανατρέξτε στην παράγραφο «Με ποιον θα πρέπει να επικοινωνήσετε για απορίες;» στο τέλος της παρούσας δήλωσης) για να μάθετε περισσότερες πληροφορίες.</p>
                <table>
                  <thead>
                  <tr>
                    <th scope="col"><b>Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε</b></th>
                    <th scope="col"><b>Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)
                    </b></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να μας ζητήσετε να αποκτήσετε πρόσβαση σε αυτά</li>
                      </ul>
                    </td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Για επιβεβαίωση των εξής:
                      <ul>
                        <li>αν επεξεργαζόμαστε ή όχι πληροφορίες που σας αφορούν,</li>
                        <li>το όνομα και τα στοιχεία επικοινωνίας μας,</li>
                        <li>τον σκοπό της επεξεργασίας,</li>
                        <li>τις κατηγορίες των σχετικών πληροφοριών,</li>
                        <li>τις κατηγορίες των ατόμων στα οποία κοινοποιούμε τις πληροφορίες και, στην περίπτωση που οποιοδήποτε πρόσωπο βρίσκεται εκτός του ΕΟΧ και δεν επωφελείται από απόφαση της Ευρωπαϊκής Επιτροπής για την επάρκεια, τα κατάλληλα μέτρα ασφαλείας για την προστασία των πληροφοριών,</li>
                        <li>(αν την διαθέτουμε) την πηγή των πληροφοριών, σε περίπτωση που δεν τις συλλέξαμε από εσάς,</li>
                        <li>(εφόσον εφαρμόζεται, για το οποίο θα σας έχουμε ενημερώσει) την ύπαρξη αυτοματοποιημένου συστήματος λήψης αποφάσεων, συμπεριλαμβανομένης της κατάρτισης προφίλ, που παράγει έννομα αποτελέσματα που σας αφορούν ή σας επηρεάζουν σημαντικά με παρόμοιο τρόπο, και πληροφορίες σχετικά με τη λογική που ακολουθείται, καθώς και τη σπουδαιότητα και τις προβλεπόμενες συνέπειες της εν λόγω επεξεργασίας για εσάς και</li>
                        <li>τα κριτήρια για τον καθορισμό της περιόδου για την οποία θα αποθηκεύσουμε τις πληροφορίες.</li>
                      </ul>
                      Κατόπιν αιτήματός σας, θα σας παρέχουμε ένα αντίγραφο των πληροφοριών σας που χρησιμοποιούμε (με την προϋπόθεση ότι αυτό δεν επηρεάζει δυσμενώς τα δικαιώματα και τις ελευθερίες άλλων).
                    </td>

                  </tr>
                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να μας ζητήσετε να τα διορθώσουμε ή να τα επικαιροποιήσουμε</li>
                      </ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Αυτό εφαρμόζεται εάν οι πληροφορίες που διατηρούμε είναι ανακριβείς ή ελλιπείς.
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να μας ζητήσετε να τα διαγράψουμε</li></ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Αυτό ισχύει εφόσον:
                      <ul>
                        <li>οι πληροφορίες που διατηρούμε δεν είναι πλέον απαραίτητες για τους σκοπούς για τους οποίους τις χρησιμοποιούμε,</li>
                        <li>χρησιμοποιούμε τις πληροφορίες με βάση τη συγκατάθεσή σας και εσείς ανακαλέσετε τη συγκατάθεσή σας (στην περίπτωση αυτή, θα φροντίσουμε να μην επικοινωνήσουμε ξανά μαζί σας, εκτός αν μας πείτε ότι θέλετε να διαγράψουμε όλες τις πληροφορίες σχετικά με εσάς, οπότε και θα σεβαστούμε την επιθυμία σας),</li>
                        <li>χρησιμοποιούμε τις πληροφορίες με βάση το έννομο συμφέρον και διαπιστώνουμε ότι, μετά την εναντίωσή σας, δεν έχουμε υπερισχύον συμφέρον να συνεχίσουμε να τις χρησιμοποιούμε,</li>
                        <li>οι πληροφορίες αποκτήθηκαν ή χρησιμοποιήθηκαν παρανόμως ή</li>
                        <li>πρέπει να συμμορφωθούμε με μια νομική υποχρέωση.</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να μας ζητήσετε να περιορίσουμε την επεξεργασία τους</li>
                      </ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Το εν λόγω δικαίωμα ισχύει, προσωρινά ενόσω εξετάζουμε την υπόθεσή σας, σε περίπτωση που:
                      <ul><li>αμφισβητείτε την ακρίβεια των πληροφοριών που χρησιμοποιούμε ή</li>
                        <li>έχετε εναντιωθεί στη χρήση των πληροφοριών βάσει έννομου συμφέροντος</li>
                        (αν ασκήσετε το δικαίωμά σας σε αυτές τις περιπτώσεις, θα σας ενημερώσουμε προτού χρησιμοποιήσουμε ξανά τις πληροφορίες). Αυτό το δικαίωμα ισχύει επίσης σε περίπτωση που:
                        <ul>
                          <li>η χρήση που κάνουμε είναι παράνομη και αντιτίθεστε τη διαγραφή των δεδομένων ή</li>
                          <li>δεν χρειαζόμαστε πλέον τα δεδομένα, αλλά μας τα ζητάτε προκειμένου να τεκμηριώσετε μία δικαστική νομική υπόθεση.</li>
                        </ul>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να εναντιωθείτε στην επεξεργασία τους</li></ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Σε αυτή την περίπτωση, έχετε δύο δικαιώματα:
                      <ol>
                        <li>(i)αν χρησιμοποιούμε πληροφορίες σας για σκοπούς άμεσης εμπορικής προώθησης, μπορείτε να διαγραφείτε (χωρίς να χρειάζεται να το αιτιολογήσετε) και θα συμμορφωθούμε με το αίτημά σας και</li>
                        <li>(ii)αν χρησιμοποιούμε πληροφορίες σας βάσει έννομου συμφέροντος για σκοπούς πέραν της εμπορικής προώθησης, μπορείτε να διατυπώσετε αντιρρήσεις σχετικά με τη χρήση τους για τους σκοπούς αυτούς, παρέχοντας εξηγήσεις για την ιδιαίτερη κατάστασή σας, και θα εξετάσουμε την εναντίωσή σας.</li>
                      </ol>
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να ανακαλέσετε την συγκατάθεσή σας για τη επεξεργασία τους</li></ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Αυτό ισχύει αν η νομική βάση σύμφωνα με την οποία χρησιμοποιούμε τις πληροφορίες σας είναι η συγκατάθεση. Αυτές οι περιπτώσεις θα προσδιορίζονται κατά περίπτωση.
                    </td>
                  </tr>

                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>στη φορητότητα των δεδομένων</li> </ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Εφόσον:
                      <ol>
                        <li>(i)μας έχετε δηλώσει δεδομένα και</li>
                        <li>(ii)τα χρησιμοποιούμε με αυτοματοποιημένα μέσα και είτε με βάση τη συγκατάθεσή σας είτε με βάση την εκπλήρωση των συμβατικών μας υποχρεώσεων προς εσάς,</li>
                      </ol>
                      τότε έχετε το δικαίωμα να λαμβάνετε τα δεδομένα σε έναν κοινώς χρησιμοποιούμενο μορφότυπο, καθώς και το δικαίωμα να ζητήσετε από εμάς να διαβιβάσουμε τα δεδομένα σε κάποιον άλλο, αν αυτό είναι τεχνικά εφικτό να πραγματοποιηθεί από εμάς.
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" data-label="Δικαίωμα όσον αφορά τα προσωπικά δεδομένα σχετικά με εσάς που τηρούμε"><br>
                      <ul>
                        <li>να υποβάλετε καταγγελία στην εποπτική αρχή της χώρας σας</li> </ul></td>
                    <td data-label="Περισσότερες λεπτομέρειες (σημείωση: ισχύουν ορισμένοι νομικοί περιορισμοί για όλα αυτά τα δικαιώματα)"><br>Κάθε χώρα του Ευρωπαϊκού Οικονομικού Χώρου πρέπει να διαθέτει μία ή περισσότερες δημόσιες αρχές για τον σκοπό αυτό. Μπορείτε να βρείτε τα στοιχεία επικοινωνίας τους εδώ: http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm Για άλλες χώρες, επισκεφτείτε τον ιστότοπο της αρχής της χώρας σας.
                    </td>
                  </tr>

                  </tbody>
                </table>
                <br>
                <h4><a id="a__Επιπλέον_σημεία_για_συγκεκριμένες_χώρες"></a>Επιπλέον σημεία για συγκεκριμένες χώρες</h4>
                <p>Ανάλογα με τη χώρα στην οποία βρίσκεστε, ενδέχεται να έχετε ορισμένα πρόσθετα δικαιώματα.</p>
                <h4><a id="a__Εάν_βρίσκεστε_στην_Ελλάδα__μάθετε_περισσότερα___"></a>Εάν βρίσκεστε στην Ελλάδα, μάθετε περισσότερα...</h4>
                <h4><a id="a__Με_ποιον_θα_πρέπει_να_επικοινωνήσετε_για_απορίες_"></a>Με ποιον θα πρέπει να επικοινωνήσετε για απορίες;</h4>
                <p>Εάν έχετε οποιεσδήποτε απορίες ή επιθυμείτε να ασκήσετε οποιοδήποτε από τα δικαιώματά σας, μπορείτε να βρείτε τα στοιχεία επικοινωνίας για τη σχετική συνδεδεμένη εταιρεία της PMI και, εφόσον υπάρχει, τον υπεύθυνο προστασίας δεδομένων, <a href="https://www.iqos.gr/index.php?dispatch=pages.contact&amp;search_contact=-1">εδώ</a>. Τα στοιχεία επικοινωνίας θα παρέχονται επίσης σε κάθε επικοινωνία που θα λαμβάνετε από τις συνδεδεμένες εταιρείες της PMI.</p>
                <p>Εάν η χώρα σας διαθέτει αρχή προστασίας δεδομένων, έχετε το δικαίωμα να επικοινωνήσετε μαζί της για τυχόν απορίες ή ζητήματα που σας απασχολούν. Εάν η σχετική συνδεδεμένη εταιρεία της PMI δεν μπορεί να επιλύσει τα ερωτήματα ή τις ανησυχίες σας, έχετε επίσης το δικαίωμα να ασκήσετε ένδικα μέσα ενώπιον των εθνικών δικαστηρίων.</p>
                <h4><a id="a__Αλλαγές_στην_παρούσα_δήλωση"></a>Αλλαγές στην παρούσα δήλωση</h4>
                <p>Μπορούμε ανά διαστήματα να ενημερώνουμε την παρούσα δήλωση (και οποιαδήποτε συμπληρωματική δήλωση απορρήτου). Θα σας ειδοποιήσουμε για τις αλλαγές, εφόσον ο νόμος το απαιτεί.</p>

                <br><br>
                <p>Τελευταία ενημέρωση: Μάιος 2022</p>
            </div>
            <div class="bottom-row">
              <Button @click="terms=false">ΚΛΕΙΣΙΜΟ</Button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Button from "@/components/Button.vue";
import axios from "axios";

const props = defineProps(['loading']);
const emit = defineEmits(['ok']);

const error = ref( false );
const terms = ref( false );

const firstname = ref("");
const lastname = ref("");
const email = ref("");
const phone = ref("");

const month = ref();
const year = ref();

const months = ref([]);
const years = ref([]);

for (let i = 1; i <= 12; i++) {
  months.value.push({
    label: i.toString(),
    value: i.toString(),
  });
}

const currentYear = ( new Date() ).getFullYear();

for (let i = currentYear - 100; i <= currentYear; i++) {
  years.value.push({
    label: i.toString(),
    value: i.toString(),
  });
}

years.value.reverse();

const validate = () => {
  // if (month.value && year.value && firstname.value && lastname.value && email.value && phone.value ) {
  if (month.value && year.value ) {
    //We need to check if the user is over 18
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;

    if (currentYear - parseInt(year.value.value) > 18) {
      //We are good to go
      // localStorage.setItem('age-verification', 'true');
      // window.location.reload();
      emit('ok');
    } else if (currentYear - parseInt(year.value.value) === 18) {
      if (currentMonth >= parseInt(month.value.value)) {
        //We are good to go
        // localStorage.setItem('age-verification', 'true');
        // window.location.reload();
        emit('ok');
      } else {
        error.value = true;
      }
    } else {
      error.value = true;
    }

    if( error.value ) {
      return;
    }

    try {
      window.gtag('event', 'age-verification');
    } catch ( e ) { console.error( e ) }

    /*axios.post(
        'https://api.iqosagrotica2024.gr/wp-json/gf/v2/forms/1/submissions',
        {
          input_1: firstname.value,
          input_3: lastname.value,
          input_6: email.value,
          input_7: phone.value,
          input_8: month.value.value,
          input_9: year.value.value,
          input_10: false,
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
    )*/
  }
}

</script>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.age-verification {
  position: fixed;
  width: 100vw;
  height: 100vh;
  height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
  //background: #f00;
  z-index: 99999;

  .age-verification__inner {
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    width: 400px;
    max-width: 100%;
    color: #F2EED9;

    @media screen and (orientation: portrait) {
      width: 360px;
    }

    & > * + * {
      margin-top: 44px;
    }

    .title {
      font-size: 70px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;

      @media screen and (orientation: portrait) {
        font-size: 48px;
      }
    }

    .subtitle {
      color: var(--iqos-white, #FFFDFB);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
      text-align: left;
    }

    .bottom-row {
      display: flex;
      flex-flow: column;
      align-items: center;
      transition: .5s ease-out;

      & > * + * {
        margin-top: 16px;
      }
    }

    .date {
      display: flex;

      & > * {
        width: 110px;
      }

      & > * + * {
        margin-left: 16px;
      }
    }

  }
}

.modal {
  .text {
    margin-top: 22px;
  }
}
.loading {
  display: flex;
  align-items: center;
  position: absolute;
  top: 26px;
  width: 100%;
  justify-content: center;
  left: 0;
  font-size: 14px;
  //font-style: italic;
  font-weight: 400;

  img {
    margin-left: 8px;
    animation: rotate 3s linear infinite;
  }
}

.hidden {
  opacity: 0;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.field {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  //grid-template-rows: repeat(2, 1fr);
  gap: 8px 12px;
  text-align: left;
  width: 100%;

  .field_title {
    color: var(--iqos-white, #FFFDFB);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  input {
    grid-row: 2;
    padding: 8px 12px;
    border-radius: 11px;
    border: 1px solid var(--iqos-turquoise, #00D1D2);
    background: var(--iqos-slate, #34303D);
    height: 42px;

    color: var(--iqos-white, #FFFDFB);
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 150%;

    &::placeholder {
      color: var(--iqos-slate-50, #9A979E);
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 150%; /* 24px */
    }
  }
  .v-select {
    grid-row: 2;
  }
}
.checkbox {
  width: 100%;
  label {
    display: flex;
    gap: 12px;
    text-align: left;
    align-items: flex-start;
    cursor: pointer;
    color: var(--iqos-white, #FFFDFB);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;

    a {
      color: var(--iqos-turquoise, #00D1D2);
      cursor: pointer;
      text-decoration: underline;
    }

    input {
      margin-top: 8px;
      display: block;
      width: 18px;
      height: 18px;
      appearance: none;
      -webkit-appearance: none;
      display: flex;
      align-content: center;
      justify-content: center;
      font-size: 2rem;
      //padding: 0.1rem;
      //border: 0.25rem solid green;
      border-radius: 4px;
      flex: 0 0 auto;

      border: 1px solid var(--iqos-turquoise, #00D1D2);

      &:checked::before {
        clip-path: polygon(41% 52%, 26% 35%, 10% 51%, 37% 88%, 37% 88%, 37% 88%, 37% 88%, 37% 88%, 91% 33%, 78% 18%);
        background: var(--iqos-turquoise, #00D1D2);
        content: "";
        width: 100%;
        height: 100%;
      }
    }
  }
}

.modal.terms {
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(217, 217, 217, 0.20);
    border-radius: 59px;
    //outline: 1px solid slategrey;
  }

  scrollbar-color: rgba(217, 217, 217, 0.20) #524F5A;
  scrollbar-width: thin;

  a {
    color: var(--iqos-turquoise, #00D1D2);
  }


  .modal-inner {
    padding: 24px 46px;
    max-width: 800px;
    border-radius: 8px;
    border: 1px solid var(--iqos-slate, #34303D);
    background: var(--iqos-slate-85, #524F5A);
    max-height: calc(100vh - 116px);
    display: flex;
    flex-flow: column;
    gap: 22px;
  }
  .text {
    overflow-y: auto;
    padding-right: 16px;
    margin-top: 0;
  }
  .bottom-row {
    display: flex;
    justify-content: flex-end;
  }
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px 16px;

    img.close {
      cursor: pointer;
    }
  }
}

.validate {
  margin-top: 42px;
}



.tab {
  margin-left: 2.5em
}

.ty-wysiwyg-content {
  margin-left: 144px;
  margin-right: 170px;
  text-align: justify;
}


/* display none for table headings */

.content-wrapper > ul:nth-child(244) > table:nth-child(3) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(1) {
  display: none;
}



.content-wrapper > ul:nth-child(244) > table:nth-child(3) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(2) > b:nth-child(1) {
  display: none;
}



.content-wrapper > ul:nth-child(244) > table:nth-child(3) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(2) {
  display: none;
}




.content-wrapper > ul:nth-child(244) > table:nth-child(6) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(1) {
  display: none;
}



.content-wrapper > ul:nth-child(244) > table:nth-child(6) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(2) {
  display: none;
}

.content-wrapper > ul:nth-child(244) > table:nth-child(7) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(1) {
  display: none;
}

.content-wrapper > ul:nth-child(244) > table:nth-child(7) > thead:nth-child(1) > tr:nth-child(1) > th:nth-child(2) {
  display: none;
}

/* end */


table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}

table tr {
  //background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  text-align: left;
}

table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }

  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }

  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 1.1em;
    text-align: left;
  }

  table td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  table td:last-child {
    border-bottom: 0;
  }
  ul{
    display: inline-block;
    text-align:left;
  }

}
</style>
